"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import Container from "@/components/Container";
import type {FrameworkBlock as FrameworkBlockProps} from "@/payload-types";
import "./index.scss";

export const FrameworkBlock: React.FC<FrameworkBlockProps> = (props) => {
	const { title, blocks } = props;

	return (
		<div className="framework_block">
			<Container>
				{title && <h2>{title}</h2>}
				<div className="framework_blocks">
					{blocks?.map((block, index) => {
						if (!block.title) return null;
						return (
							// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
							<div className="content_blocks" key={index}>
								<div className="content_blocks-grid">
									{block?.content?.map((content, index) => (
										// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
										<div className="single_block" key={index}>
											{/*<h3>{content.title}</h3>*/}
											<h3>
												{content.titleFirst} <br />
												{content.titleSecond}
											</h3>
											<p>{content.text}</p>
										</div>
									))}
								</div>
								<div className="single_block-footer">
									<p>{block.title}</p>
								</div>
							</div>
						);
					})}
				</div>
			</Container>
		</div>
	);
};
